import * as React from "react";
import Select, {
    Props as SelectProps,
    GroupBase,
    components as RSComponents,
} from "react-select";

import CloseIcon from "../Icons/CloseIcon";
import { CreatableProps } from "react-select/creatable";
import Creatable from "react-select/creatable";

export interface LabelValueOption {
    label: string;
    value: string;
}

export const ClearIndicator = (p: any) => (
    <RSComponents.ClearIndicator {...p}>
        <CloseIcon width={24} height={24} />
    </RSComponents.ClearIndicator>
);

export const MultiValueRemove = (p: any) => (
    <RSComponents.MultiValueRemove {...p}>
        <CloseIcon width={20} height={20} />
    </RSComponents.MultiValueRemove>
);

export function CustomSelectWrapper<
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>(props: SelectProps<Option, IsMulti, Group>) {
    return (
        <Select
            {...props}
            className="react-select-container"
            classNamePrefix="react-select"
            components={{
                ...props.components,
                ClearIndicator,
                MultiValueRemove,
            }}
            placeholder={props.placeholder || "Select..."}
        />
    );
}

export function CreatableWrapper<
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>(props: CreatableProps<Option, IsMulti, Group>) {
    return (
        <Creatable
            {...props}
            className="react-select-container"
            classNamePrefix="react-select"
            components={{
                ...props.components,
                ClearIndicator,
                MultiValueRemove,
            }}
            placeholder={props.placeholder || "Select..."}
        />
    );
}
